export function setEnvironmentVariable(currentLocation: string) {
	switch (currentLocation) {
		case 'localhost':
			// When customer portal is external, change this to gatewaypublic-test.tofindout.se
			(window as any).tfoEnv = "gatewaypublic.test.tofindout.io/api/v1"
			break;
		case 'customer-test.tofindout.se':
			(window as any).tfoEnv = "gatewaypublic-test.tofindout.se/api/v1"
			break;
		case 'customer.tofindout.se':
			(window as any).tfoEnv = "gatewaypublic.tofindout.se/api/v1"
			break;
		case 'customer.test.tofindout.io':
			(window as any).tfoEnv = "gatewaypublic.test.tofindout.io/api/v1"
			break;
		default:
			(window as any).tfoEnv = "gatewaypublic.tofindout.se/api/v1"
			break;
	}
}

export function showTemporaryMessageStartPage() {
    const now = new Date();
    const currentYear = now.getFullYear();

    return between(now, 
        new Date(`${currentYear}-06-23`), 
        new Date(`${currentYear}-08-25`))
}

export function showTemporaryMessageOrderFormSubmit() {
    const now = new Date();
    const currentYear = now.getFullYear();

    return between(now, 
        new Date(`${currentYear}-06-23`), 
        new Date(`${currentYear}-08-25`))
}

export function showTemporaryMessageOrderFormShareReport() {
    const now = new Date();
    const currentYear = now.getFullYear();

    return between(now, 
        new Date(`${currentYear}-06-23`), 
        new Date(`${currentYear}-08-25`))
}

function between(timestamp: Date, start: Date, end: Date) {
	return start <= timestamp && timestamp <= end
}